import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';
import Vue from 'vue';

Vue.prototype.$general = {
  getLanguageList(){
    const data = request({
      url: config.url+'language/getDataList',
      method: 'get',
    });
    return Promise.resolve(data);
  },
  getToolList: function(){
    var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
    const data = request({
        url: config.url+'general?language='+language+'&getAll=1',
        method: 'get'
    });

    return Promise.resolve(data);
  }
}

export default {
  install(Vue, options) {
    Vue.prototype.$general;
  }
}   